<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('units_of_measure.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openUnitOfMeasureForm"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetUnitsOfMeasure(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="units_of_measure" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openUnitOfMeasureForm(props.item)">
                                <td>{{ props.item.id }}</td>
                                <td>{{ props.item.unit }}</td>
                                <td>{{ props.item.unit_abbrev }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="units_of_measure"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="unit_of_measure_dialog">
                <v-card>
                    <v-form ref="form_unit_of_measure">
                        <v-card-title>
                            <span class="headline">{{ unit_of_measure.id ? $t("lang.edit_unit_of_measure") : $t("lang.add_unit_of_measure") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeUnitOfMeasureDialog"
                                :dialog-status="unit_of_measure_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <!-- <v-flex xs12>
                                        <v-text-field
                                            v-focus="unit_of_measure_dialog"
                                            v-model="unit_of_measure.id"
                                            :label="$t('lang.id')"
                                            :counter="showCounter(unit_of_measure.id, 'units_of_measure.id')"
                                            :rules="ifValid('units_of_measure.id')"
                                        ></v-text-field>
                                    </v-flex> -->
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="unit_of_measure.unit"
                                            :label="`${$t('lang.unit')} *`"
                                            :counter="showCounter(unit_of_measure.unit, 'units_of_measure.unit')"
                                            :rules="ifValid('units_of_measure.unit')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="unit_of_measure.unit_abbrev"
                                            :label="`${$t('lang.unit_abbrev')} *`"
                                            :counter="showCounter(unit_of_measure.unit_abbrev, 'units_of_measure.unit_abbrev')"
                                            :rules="ifValid('units_of_measure.unit_abbrev')"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="unit_of_measure.id" color="error" @mouseup.left="$refs.delete_units_of_measure.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeUnitOfMeasureDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveUnitsOfMeasure">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_units_of_measure"
                :heading="$t('lang.delete_unit_of_measure')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteUnitsOfMeasure(unit_of_measure.id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openUnitOfMeasureForm" },
                { title: this.$t("lang.refresh"), action: "dbGetUnitsOfMeasure", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.id"), sortable: false, width: "33%" },
                { text: this.$t("lang.unit"), sortable: false, width: "33%" },
                { text: this.$t("lang.unit_abbrev"), sortable: false, width: "33%" },
            ],
            enableAddModal: true,
            enableEditModal: true,

            unit_of_measure: {},
            filter: {
                search: "",
            },
            unit_of_measure_dialog: false,
            dbGetUnitsOfMeasure: _.debounce(this.getUnitsOfMeasure, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchUnitsOfMeasure", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.units_of_measure) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchUnitsOfMeasure({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.units_of_measure) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.units_of_measure.units_of_measure_filter,
            page: (state) => state.units_of_measure.page,
            rules_units_of_measure: (state) => state.units_of_measure.rules_units_of_measure,
            unit_of_measure_status_options: (state) => state.settings.unit_of_measure_status_options,
            units_of_measure: (state) => state.units_of_measure.units_of_measure,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchUnitsOfMeasure", "saveUnitOfMeasure", "deleteUnitOfMeasure"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openUnitOfMeasureForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_unit_of_measure) item ? this.$refs.form_unit_of_measure.resetValidation() : this.$refs.form_unit_of_measure.reset();

                    this.$nextTick(() => {
                        this.unit_of_measure = item != null ? this.assignObj2(item, this.rules_units_of_measure) : {};
                        this.unit_of_measure_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "unit_of_measure", params: { id: item.id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_unit_of_measure) item ? this.$refs.form_unit_of_measure.resetValidation() : this.$refs.form_unit_of_measure.reset();
                    this.unit_of_measure_dialog = true;
                } else {
                    this.$router.push({ name: "unit_of_measure" });
                }
            }
        },
        saveUnitsOfMeasure() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_unit_of_measure")) {
                    let body = this.prepForm(this.unit_of_measure, this.rules_units_of_measure);

                    this.saveUnitOfMeasure({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getUnitsOfMeasure();
                                this.closeUnitOfMeasureDialog();
                            } else {
                                this.$router.push({ name: "unit_of_measure", params: { id: data.id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteUnitsOfMeasure(id = null) {
            this.deleteUnitOfMeasure({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getUnitsOfMeasure();
                    this.closeUnitOfMeasureDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeUnitOfMeasureDialog() {
            this.unit_of_measure_dialog = false;
            this.$refs.delete_units_of_measure.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getUnitsOfMeasure(pg_refresh = false) {
            this.startLoader();

            this.fetchUnitsOfMeasure({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                    console.log(this.page);
                })
                .finally(() => {
                    this.unit_of_measure_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
    },
};
</script>
